<template>
    <div class="pd15 tableScope bgContent">
        <div class="table table-5x tra-fast posR"  fillHeight="lastHeight,-48" v-permissions="'A/D/A'" permission-type="none">
            <loading v-show="isEmpty"></loading>
            <div class="cb bgContent" v-show="relevantPerson.length">
                <div class="tableSys head noSelect cField bdLight-bottom" >
                    <div>{{$t('word1319',['备注名'])}}</div>
                    <div>{{$t('word90',['角色'])}}</div>
                    <div>{{$t('word1320',['职能'])}}</div>
                    <div>{{$t('word1321',['部门'])}}</div>
                    <div v-if="stage.loc.loginSystem.um">{{$t('other4',['UM帐号'])}}</div>
                    <div>>{{$t('word658',['手机号'])}}</div>
                    <div>{{$t('word68',['邮箱'])}}</div>
                    <div v-permissions="'A/D/C'" permission-type="none">{{$t('word47',['操作'])}}</div>
                </div>
                <div class="fixedScrollBar scrollY tra-fast"  fillHeight="lastHeight,-48" scroll>
                    <table >
                        <thead class="head-token">
                            <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th v-if="stage.loc.loginSystem.um"></th>
                                <th></th>
                                <th></th>
                                <th v-permissions="'A/D/C'" permission-type="none"></th>
                            </tr>
                        </thead>
                        <tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
                            <tr v-for="(item,index) in relevantPerson" :key="index" >
                                <td>
                                    <span v-if="item.orgUserDto.orgUser.markName != null">{{item.orgUserDto.orgUser.markName}}</span>
                                    <span v-else>--</span>
                                    <br>
                                    <span class="s-box" v-if="DetailInfo.createdBy==item.orgUserDto.orgUser.id">{{$t('word774',['管理者'])}}</span>
                                </td>
                                <td><span v-if="item.role && item.role.roleName != null">{{item.role.roleName}}</span><span v-else>{{$t('word1333',['默认普通用户'])}}</span></td>
                                <td><span v-if="item.function && item.function.roleName != null">{{item.function.roleName}}</span><span v-else>{{$t('word1333',['默认普通用户'])}}</span></td>
                                <td><span v-if="item.orgUserDto.groupName != null">{{item.orgUserDto.groupName}}</span><span v-else>--</span></td>
                                <td :title="item.orgUserDto.userInfo.umAccount||''" v-if="stage.loc.loginSystem.um">
                                    {{item.orgUserDto.userInfo.umAccount}}
                                </td>
                                <td><span v-if="item.orgUserDto.userInfo.phoneNumber">{{item.orgUserDto.userInfo.phoneNumber}}</span><span v-else>--</span></td>
                                <td><span v-if="item.orgUserDto.userInfo.email">{{item.orgUserDto.userInfo.email}}</span><span v-else>--</span></td>
                                <td v-permissions="'A/D/C'" permission-type="none">
                                    <button class="hover-c-error hover-f-error fa fa-chain-broken f15" type="button" @click="_confirmDels(item.orgUserDto.orgUser.id)" :title="$t('cmd134',['解除关联'])"></button>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
            <no-result v-if="!relevantPerson.length&&isEmpty==false"></no-result>
        </div>
        <div class="tableBatch bgContent cSub sPagination" :class="{disable:!pagination.total}" v-permissions="'A/D/A'" permission-type="none">
            <Pagination class="ml2x" :pagination="pagination"   :getList="_getListPage"></Pagination>
        </div>
    </div>
</template>
<script>
import {mapGetters,mapMutations,mapActions} from 'vuex'
import Pagination from "@/components/common/ui/Pagination.vue";
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading';

import * as lib from "@/util/lib.js";
import {AssociatedPerson,AssociatedPersonDel} from  "@/api/maintain/plant/list.js"
import {getRoleScope} from  "@/api/manage/roleFunc.js"
export default {
    components:{Pagination,NoResult,Loading},
    props:{
        DetailInfo:{
			type:Object,
			default:()=>({})
		},
    },
    data(){
        return{
            id:'',
            watcherId:'',
            stage,
        }
    },
    computed:{
        ...mapGetters({
            PersonStatus:'equipment/PersonStatus',
            relevantPerson:'stationDetail/relevantPerson',
            isEmpty:'stationDetail/isEmpty',
            pagination:'stationDetail/pagination'
        })
    },
    watch:{
        // PersonStatus(val){
        //    if(val==1){
        //         this._delPerson()
        //    }
        // }
    },
    methods:{
        ...mapMutations({
            PERSONSTATUS:'equipment/PERSONSTATUS'
        }),
        ...mapActions({
            GetPerson:'stationDetail/GetPerson'
        }),
        //删除
        _delPerson(){
            AssociatedPersonDel(this.DetailInfo.id,this.watcherId).then(response=>{
                // this.PERSONSTATUS(0)
                let pages={page:this.pagination.request.page,size:this.pagination.request.size}
                this.GetPerson(pages).then(res=>{
                    this.$emit('update')
                }).catch(error=>{
                    if(error=='没有操作权限'){
                        this.$emit('closePage')
                    }
                })
            },error=>{
                !_.isEmpty(error) && this.$notify(error)
            })
        },
        //确认删除
        _confirmDels(data){
            this.watcherId=data
            this.$emit('confirmDels',data)
        },
        //翻页
        _getListPage(){
            let pages={page:this.pagination.request.page,size:this.pagination.request.size}
            this.GetPerson(pages).then(res=>{
            }).catch(error=>{
                !_.isEmpty(error) && this.$notify(error)
            })
        }
    }
}
</script>

<style  lang="scss" scoped >
.pd15{background: #fff}
.f15{ font-size: 15px }
.s-box{
    display: inline-block;
    background: #FF7020;
    padding: 0 0.3em;
    color: #fff;
    margin-top:.2em
}
</style>




// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/RelevantPerson.vue